import store from "@/store/index.js";

export default [
  {
    path: "/website-descriptions",
    name: "WebsiteDescriptions",
    meta: { requiresAuth: true },
    component: () => import("@/views/WebsiteDescriptions.vue"),
		beforeEnter:  async (to, from, next) => {
			await store.dispatch("fetchDescriptions", to.query.page);
			next();
		}
	},
  {
    path: "/website-description-create",
    name: "DescriptionCreate",
    meta: { requiresAuth: true },
    component: () =>
      import("@/components/WebsiteDescriptions/DescriptionCreate.vue")
  },
  {
    path: "/website-description-read/:id",
    name: "DescriptionRead",
    meta: { requiresAuth: true },
    component: () =>
      import("@/components/WebsiteDescriptions/DescriptionRead.vue"),
		beforeEnter: async (to, from, next) => {
			await store.dispatch("fetchOneDescription", to.params.id);
			next();
		}
  },
  {
    path: "/website-description-edit/:id",
    name: "DescriptionEdit",
    meta: { requiresAuth: true },
    component: () =>
      import("@/components/WebsiteDescriptions/DescriptionEdit.vue"),
		beforeEnter: async (to, from, next) => {
			await store.dispatch("fetchOneDescription", to.params.id);
			next();
		}
  }
];
